import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/GasCheckoutDataProvider";
import NewHeadline from "../../../../shared/NewHeadline";
import OrderChoiceButtons from "../../../../shared/OrderChoiceButtons";
import RemittancePayment from "./RemittancePayment";
import SepaPayment from "./SepaPayment";

const StepPaymentType = () => {
    const dataContext = useContext(DataContext);
    const { gasPaymentTypes, paymentData } = dataContext.data;
    const { paymentTypeHasChanged, setPaymentData } = dataContext.actions;

    const onChangePaymentType = (value) => {
        setPaymentData({
            ...paymentData,
            ...{ payment_payment_type: value },
        });
        paymentTypeHasChanged();
    };
    return (
        <section>
            <NewHeadline>Zahlart</NewHeadline>
            <OrderChoiceButtons
                choices={gasPaymentTypes}
                activeId={paymentData.payment_payment_type}
                onChoiceChange={onChangePaymentType}
                hasSubtitle={false}
            />

            <SepaPayment />
            <RemittancePayment />
        </section>
    );
};

export default StepPaymentType;
